import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { lastValueFrom } from 'rxjs';

import { TextInputComponent } from 'app/ui-components/text-input/text-input.component';

import { ToastrService } from '../../shared/service/toastr.service';
import { ListsService } from '../lists.service';

@Component({
  selector: 'cc-add-list-modal',
  templateUrl: './add-list-modal.component.html',
  styleUrls: ['./add-list-modal.component.scss'],
})
export class AddListModalComponent implements AfterViewInit {
  @Input() parentPath = '';
  @Input() autoFocusInputOnOpen = true;
  @ViewChild(TextInputComponent) textInputComponent: TextInputComponent;

  listName = '';
  isSaving = false;

  constructor(
    private readonly activeModal: NgbActiveModal,
    private readonly listsService: ListsService,
    private readonly toast: ToastrService,
  ) {}

  ngAfterViewInit() {
    if (this.autoFocusInputOnOpen) {
      this.textInputComponent.focus();
    }
  }

  cancelListCreation() {
    this.activeModal.dismiss();
  }

  async createList(event: Event) {
    event.preventDefault();
    if (this.isSaving || this.listName === '') {
      return;
    }

    try {
      this.isSaving = true;
      const newList = await lastValueFrom(this.listsService.saveFolderList(this.parentPath, this.listName));
      this.activeModal.close(newList);
      this.toast.successByKey('listAdded');
    } catch (err) {
      this.toast.errorByKey('failedToAddList');
    }
    this.isSaving = false;
  }
}
